import Button from '@src/components/atoms/buttons/button';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
}
export default function Pagination({
  page,
  totalPages,
  onNext,
  onPrevious,
}: PaginationProps) {
  return (
    <div className="flex items-center justify-between gap-2 border border-dark-neutral-700 bg-dark-neutral-800 p-3">
      <p className="body14 font-medium dark:text-white">
        Page {page} of {totalPages}
      </p>
      <div className="flex items-center gap-3">
        <Button disabled={page <= 1} onClick={onPrevious} variant="neutral">
          Previous
        </Button>

        <Button
          disabled={page >= totalPages}
          onClick={onNext}
          variant="neutral"
        >
          Next
        </Button>
      </div>
    </div>
  );
}

//THis is specifically created to be shared among drep tabs
export interface IPaginationDetails {
  currentPage: number;
  size: number;
  totalCount: number;
  onNext: () => void;
  onPrevious: () => void;
}
